import { messages } from './messages';
import { SKU_SOURCE_UI_VALUES } from '../../../../../utils/sku-source-conversion';

export const pickListGroupings = [
  {
    value: 'Both',
    messageDescriptor: messages.summarizeByBoth,
  },
  {
    value: 'SKU',
    messageDescriptor: messages.summarizeBySku,
  },
  {
    value: 'Name',
    messageDescriptor: messages.summarizeByName,
  },
  {
    value: 'None',
    messageDescriptor: messages.doNotSummarize,
  },
];

export const pickListSortings = [
  {
    value: 'Items',
    messageDescriptor: messages.orderItemsByItems,
  },
  {
    value: 'SKU',
    messageDescriptor: messages.orderItemsBySku,
  },
  {
    value: 'Name',
    messageDescriptor: messages.orderItemsByName,
  },
  {
    value: 'WarehouseLocation',
    messageDescriptor: messages.orderItemsByWarehouse,
  },
  {
    value: 'WarehouseLocation,SKU',
    messageDescriptor: messages.orderItemsByWarehouseThenSku,
  },
];

export const pickListWarehouseLocations = [
  {
    value: 'Shipping',
    messageDescriptor: messages.shippingLocation,
  },
  {
    value: 'Inventory',
    messageDescriptor: messages.inventoryLocation,
  },
];

export const pickListSkuSources = [
  {
    value: SKU_SOURCE_UI_VALUES.SELLING_CHANNEL,
    messageDescriptor: messages.sellingChannelSku,
  },
  {
    value: SKU_SOURCE_UI_VALUES.SHIPSTATION_CATALOG,
    messageDescriptor: messages.shipstationProductCatalogSku,
  },
];
